module.exports = __webpack_public_path__ + "static/media/fly0206.10518d45.webp";